import { render, staticRenderFns } from "./AppCadastroAgendaAluno.vue?vue&type=template&id=3c1857b3&"
import script from "./AppCadastroAgendaAluno.vue?vue&type=script&lang=js&"
export * from "./AppCadastroAgendaAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports